import { useScroll } from "framer-motion";

export const useScrollState = () => {
  const { scrollYProgress } = useScroll();
  return {
    progress: scrollYProgress,
  };
};
